import { combineReducers } from 'redux'
import graphite from './graphite';
import icinga from './icinga';

export default combineReducers({ icinga, graphite });



// WEBPACK FOOTER //
// ./src/reducers/index.js